<template>
  <div class="date-pickers">
    <input type="text" placeholder="选择日期" @click="openDateFrame" :value="chooseDate" readonly />
    <transition name="fade" class="fade-enter fade-enter-active fade-leave-active" v-if="dateBoxFlag">
      <div>
        <div class="day-select">
          <div class="day_select_left">
            <button @click="reduceYear">&laquo;</button>
            <button @click="reduceMonth">&lt;</button>
          </div>
          <div class="day_select_center">
            <input type="text" v-model="year"  class="day_select_center_left"/>年
            <input type="text" v-model="month" class="day_select_center_right"/>月
          </div>
          <div class="day_select_right">
            <button @click="addMonth">&gt;</button>
            <button @click="addYear">&raquo;</button>
          </div>
        </div>
        <div class="day-screen">
          <div class="day_screen_left">
            <span  v-for="week in weekList">{{ week }}</span>
          </div>
          <div @click="selectDay" class="day_screen_right">
            <span v-for="day in previousMonth" class="previousMonth">{{ day }}</span>
            <span v-for="day in monthDay[month - 1]" v-bind:class="isActive(day)" class="currentMonth">{{ day }}</span>
            <span v-for="day in nextMonth" class="nextMonth">{{ day }}</span>
          </div>
        </div>
        <div class="footer" style="">
          <button class="option" @click="closeDateFrame('cancel')">取消</button>
          <span  class="showConfirm">{{date}}</span>
          <button class="option" @click="closeDateFrame('confirm')">确定</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'datePickers',
    data () {
      return {
        dateBoxFlag: false,
        year: 0,
        month: 0,
        day: 0,
        previousMonth: [],// 上个月的天数
        nextMonth: [],// 下个月的天数
        weekList: ['日', '一', '二', '三', '四', '五', '六'],
        monthDay: [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        chooseDate:''
      }
    },
    computed: {
      date () {
        if (this.year === 0 || this.month === 0 || this.day === 0) {
          return '';
        }
        if(this.month<10){
          if(this.day<10){
            return this.year + '-' + ('0'+this.month) + '-' + ('0'+ this.day);
          }
          return this.year + '-' + ('0'+this.month) + '-' + this.day;
        }
        if(this.month>=10 && this.day <10){
          return this.year + '-' + this.month + '-' + ('0'+ this.day);
        }

        return this.year + '-' + this.month + '-' + this.day;
      }
    },
    watch: {
      year: function (val) {
        let reg = /^[1-9]\d*$/g;
        if (!reg.test(val)) {
          let date = new Date();
          this.year = date.getFullYear();
        }
        if (val < 0) {
          this.year = 1;
        }
        if (val > 10000) {
          this.year = 10000;
        }
        this.dayScreen();
      },
      month: function (val) {
        let reg = /^[1-9]\d*$/g;
        if (!reg.test(val)) {
          let date = new Date();
          this.month = date.getMonth() + 1;
        }
        if (val < 1) {
          this.month = 1;
        }
        if (val > 12) {
          this.month = 12;
        }
        this.dayScreen();
      },
    },
    methods: {
      // 突出显示当前日期
      isActive (index) {
        if (index === this.day) {
          return {
            active: true,
          }
        }
      },
      // 显示日期盒子并初始化
      openDateFrame () {
        if (this.date === '') {
          let date = new Date();
          this.year = date.getFullYear();
          if (this.isLeapYear(this.year)) {
            this.monthDay[1] = 29;
          } else {
            this.monthDay[1] = 28;
          }
          this.month = date.getMonth() + 1;
          this.day = date.getDate();
        }
        this.dateBoxFlag = true;
      },
      // 增减年份
      addYear () {
        this.year++;
        if (this.isLeapYear(this.year)) {
          this.monthDay[1] = 29;
        } else {
          this.monthDay[1] = 28;
        }
      },
      reduceYear () {
        this.year--;
        if (this.isLeapYear(this.year)) {
          this.monthDay[1] = 29;
        } else {
          this.monthDay[1] = 28;
        }
      },
      // 增减月份
      addMonth () {
        this.month++;
        if (this.month > 12) {
          this.month = 1;
          this.year++;
        }
      },
      reduceMonth () {
        this.month--;
        if (this.month < 1) {
          this.month = 12;
          this.year--;
        }
      },
      // 选择日期
      selectDay (e) {
        let targetClass = e.target.className;
        if (targetClass === 'previousMonth') {// 点击类名是上个月
          if (this.month === 1) {
            this.month = 12;
            this.year--;
          } else {
            this.month = this.month - 1;
          }
          this.day = parseInt(e.target.innerText);
        } else if (targetClass === 'nextMonth') {
          if (this.month === 12) {
            this.month = 1;
            this.year++;
          } else {
            this.month = this.month + 1;
          }
          this.day = parseInt(e.target.innerText);
        } else {
          this.day = parseInt(e.target.innerText);
        }
      },
      // 日期显示
      dayScreen () {
        // 上一个月
        let firstDate = new Date(this.year, this.month - 1, 1);// 获取当前月的第一天
        let firstWeek = firstDate.getDay();// 获取第一天是星期几
        let preMonthDay = null;
        if (this.month === 1) {// 如果月份等于1上个月天数等于12月的天数
          preMonthDay = this.monthDay[11];
        } else {
          preMonthDay = this.monthDay[this.month - 2];
        }
        for (let i = 0; i < preMonthDay; i++) {// 拿到上个月的天数转为数组
          this.previousMonth[i] = i + 1;
        }
        if (firstWeek === 0) {// 如果当前月的第一天是星期日，则截取上个月的数组的后七位
          this.previousMonth = this.previousMonth.slice(-7);
        } else {
          this.previousMonth = this.previousMonth.slice(-firstWeek);
        }
        // 下一个月
        let endDate = new Date(this.year, this.month - 1, this.monthDay[this.month - 1]);
        let endWeek = endDate.getDay();
        let nextMonthDay = null;
        if (this.month === 12) {
          nextMonthDay = this.monthDay[0];
        } else {
          nextMonthDay = this.monthDay[this.month];
        }
        for (let i = 0; i < nextMonthDay; i++) {
          this.nextMonth[i] = i + 1;
        }
        if (endWeek === 6) {// 如果当前月最后一天星期六，截取下个月天数数组的前七位
          this.nextMonth = this.nextMonth.slice(0, 7);
        } else {
          this.nextMonth = this.nextMonth.slice(0, 6 - endWeek);
        }
      },
      // 判断是否是闰年
      isLeapYear (year) {
        return (year % 100 === 0 ? (year % 400 === 0 ? true : false) : (year % 4 === 0 ? true : false));
      },
      closeDateFrame(data){// 关闭
        if(data === 'confirm'){
          this.chooseDate = this.date;
          this.$emit('update:dateValue',this.date);
        }
        this.dateBoxFlag = false;
      }
    }
  }
</script>

<style>
  .date-pickers {
    width: 280px;
    padding: 5px;
  }
  .date-pickers input{
    height: 20px;
    padding: 5px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all 0.5s;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
    transform: translateY(-10px);
  }
  .date-pickers div{
    width: 100%;
    z-index: 99;
  }
  .day-select {
    display: flex;
    padding: 5px 0;
    height: 30px;
    line-height: 30px;
    color: #888888;
    border-bottom: 1px solid #ccc;
  }
  .day-select input, button {
    border: none;
    background: white;
    text-align: center;
    color: #888888;
    cursor: pointer;
  }
  .day_select_left ,.day_select_right{
    width: 20%;
  }
  .day_select_center{
    width: 60%;
    display: flex;
    justify-content: center;
  }
  .day_select_center input:hover{
    background: #eee;
  }
  .day_select_center_left{
    width: 50px;
  }
  .day_select_center_right{
    width: 30px;
  }
  .day_screen_left span{
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    display:-moz-inline-box;
    display:inline-block;
    border-bottom: 1px solid #ccc;
    font-weight: bold;
    background: #F8F8F8;
  }
  .day_screen_right span{
    width: 40px;
    height: 40px;
    float: left;
    /*display:-moz-inline-box;*//*注释掉的部分作用是：给span设置宽高，并使其不换行*/
    /*display:inline-block;*/
    /*margin-right: -4px;*/
    text-align: center;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    color: black;
  }
  .day_screen_right span:hover{
    background: #21A5EF;
    color: white;
  }
  .active{
    background: #21A5EF;
    color: white;
  }
  span.previousMonth,span.nextMonth {
    color: #888888;
  }
  .footer{
    height: 40px;line-height: 40px;
  }
  .option{
    font-size: 16px;background: #21A5EF;color: #fff;border-radius: 4px
  }
  .showConfirm{
    margin: 0 40px;color: orangered;
  }
</style>



// WEBPACK FOOTER //
// src/components/datePicker.vue